import { supabase } from './supabaseClient';

/** Call an authenticated Netlify function and surface its JSON error. */
export async function callLambda<T = unknown>(path: string, init: RequestInit = {}): Promise<T> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) throw new Error('Not authenticated');
  const response = await fetch(`/.netlify/functions/${path}`, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...init.headers, Authorization: `Bearer ${token}` },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error((body as { error?: string }).error || `Request failed: ${response.status}`);
  return body as T;
}
